import AppAuth from './Auth'
import AccountSettings from "./AccountSettings"
import AppSettings from "./admin/Settings";
import AppUser from "./user";
import userManagement from "./admin/UserManagement";
import langConfig from "@configs/langConfig"

const {t} = langConfig
import {lazy} from 'react'

// ** Document title
const TemplateTitle = '%s - PhishTIP'

// ** Default Route

const DefaultRoute = '/dashboard'

const Routes = [
    ...AppAuth,
    ...AccountSettings,
    ...AppSettings,
    ...AppUser,
    ...userManagement,
    {
        path: '/dashboard',
        title: t('Dashboard'),
        component: lazy(() => import('../../views/Home')),
        meta: {
            authRoute: false
        }
    },
    {
        path: '/admin/phishing-feed',
        title: t('Phishing feed'),
        component: lazy(() => import('../../views/admin/phishing-feed')),
        meta: {
            authRoute: false,
            isAdmin: true,
        }
    },
    {
        path: '/search',
        title: t('Search'),
        component: lazy(() => import('../../views/search')),
        meta: {
            authRoute: false,
        }
    },
    {
        path: '/ip-and-countries',
        title: t('Search'),
        component: lazy(() => import('../../views/IPAndCountries')),
        meta: {
            authRoute: false,
        }
    },
    {
        path: '/admin/settings/api/keys',
        title: t('Search'),
        component: lazy(() => import('../../views/admin/settings/api-keys')),
        meta: {
            authRoute: false,
        }
    },
    {
        path: '/error',
        title: t('404'),
        component: lazy(() => import('../../views/Error')),
        layout: 'BlankLayout',
        meta: {
            authRoute: false
        }
    },
    {
        path: '/server-error',
        title: t('500'),
        component: lazy(() => import('../../views/error/Error500')),
        layout: 'BlankLayout',
        meta: {
            authRoute: false
        }
    }
]

export {DefaultRoute, TemplateTitle, Routes}
